"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Localization = void 0;
const libs_i18n_core_1 = require("libs.i18n-core");
const types_1 = require("./types");
const utils_1 = require("./utils");
function deepEqual(obj1, obj2) {
    if (obj1 === obj2) {
        return true;
    }
    if (typeof obj1 !== 'object' || obj1 === null || typeof obj2 !== 'object' || obj2 === null) {
        return false;
    }
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length) {
        return false;
    }
    for (const key of keys1) {
        if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
            return false;
        }
    }
    return true;
}
const defaultInitBaseLocale = libs_i18n_core_1.Locale.en_US;
/**
 * See documentation at docs/libs/localization.md
 */
class Localization {
    constructor(assetOrId, options = {}) {
        let humanId;
        const { baseLocale } = options;
        if (typeof assetOrId === 'string') {
            this.id = assetOrId;
            if (assetOrId.startsWith('product_')) {
                humanId = assetOrId;
            }
        }
        else {
            this.id = (0, utils_1.assetToId)(assetOrId);
            humanId = (0, utils_1.assetToHumanId)(assetOrId);
        }
        this.initBaseLocale = baseLocale;
        this.initHumanId = humanId !== null && humanId !== void 0 ? humanId : options.humanId;
    }
    setMessages(locale, namespaces, origin = types_1.LocalizationOrigin.USER) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            let cleanedUpEntry;
            const data = {};
            const localizationResourceDataSet = new Set();
            const entry = yield this.getDatabaseEntry();
            const baseLocale = yield this.getBaseLocale(entry);
            const humanId = (_a = entry === null || entry === void 0 ? void 0 : entry.human_id) !== null && _a !== void 0 ? _a : this.initHumanId;
            let didSetLocalizationResourceRun = false;
            if (namespaces.some(({ namespace }) => namespace === '_identity')) {
                throw new Error('_identity is a reserved namespace name.');
            }
            const setInitialData = () => {
                data.base_locale = baseLocale;
                data.human_id = humanId;
            };
            const setLocalizationResource = () => {
                var _a;
                didSetLocalizationResourceRun = true;
                // Prepare cleanedUpEntry by cloning the current entry and removing old localization resources for the current locale.
                cleanedUpEntry = cleanedUpEntry !== null && cleanedUpEntry !== void 0 ? cleanedUpEntry : entry;
                cleanedUpEntry = Object.assign(Object.assign({}, cleanedUpEntry), { localization_resources: Object.assign({}, cleanedUpEntry === null || cleanedUpEntry === void 0 ? void 0 : cleanedUpEntry.localization_resources) });
                (_a = cleanedUpEntry.localization_resources) === null || _a === void 0 ? true : delete _a[locale];
                data.localization_resources = {
                    [locale]: Object.assign({}, ...namespaces.map(({ namespace, messages }) => ({
                        [namespace]: messages,
                    }))),
                };
            };
            let isDiffCache;
            const isDiff = () => {
                var _a, _b;
                if (isDiffCache === undefined) {
                    const currLocalizationResource = (_a = entry === null || entry === void 0 ? void 0 : entry.localization_resources) === null || _a === void 0 ? void 0 : _a[locale];
                    if (((_b = data.localization_resources) === null || _b === void 0 ? void 0 : _b[locale]) && currLocalizationResource) {
                        isDiffCache = !deepEqual(data.localization_resources[locale], currLocalizationResource);
                    }
                    else {
                        isDiffCache = false;
                    }
                }
                return isDiffCache;
            };
            const invalidateAllLocales = () => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                if (!isDiff()) {
                    return;
                }
                data.supported_locales = (_a = data.supported_locales) !== null && _a !== void 0 ? _a : {};
                for (const supportedLocale of Object.keys((_b = entry === null || entry === void 0 ? void 0 : entry.supported_locales) !== null && _b !== void 0 ? _b : {})) {
                    if (supportedLocale === baseLocale) {
                        continue;
                    }
                    if (((_d = (_c = entry === null || entry === void 0 ? void 0 : entry.supported_locales) === null || _c === void 0 ? void 0 : _c[supportedLocale]) === null || _d === void 0 ? void 0 : _d.status) === types_1.LocalizationStatus.READY) {
                        const currVersion = (_f = (_e = entry === null || entry === void 0 ? void 0 : entry.supported_locales) === null || _e === void 0 ? void 0 : _e[supportedLocale]) === null || _f === void 0 ? void 0 : _f.version;
                        if (!currVersion) {
                            throw new Error('Internal error');
                        }
                        const last_updated = new Date();
                        data.supported_locales[supportedLocale] = {
                            locale: supportedLocale,
                            last_updated,
                            last_exported_at: null,
                            version: currVersion + 1,
                            status: types_1.LocalizationStatus.IN_PROGRESS,
                            localization_origin: origin,
                        };
                        const baseLocaleVersion = (_h = (_g = entry === null || entry === void 0 ? void 0 : entry.supported_locales) === null || _g === void 0 ? void 0 : _g[baseLocale]) === null || _h === void 0 ? void 0 : _h.version;
                        if (!baseLocaleVersion) {
                            throw new Error('Internal error');
                        }
                        localizationResourceDataSet.add({
                            locale: supportedLocale,
                            last_updated,
                            base_locale_version: baseLocaleVersion + 1,
                            version: currVersion + 1,
                            status: types_1.LocalizationStatus.IN_PROGRESS,
                            localization_resource: (_j = entry === null || entry === void 0 ? void 0 : entry.localization_resources) === null || _j === void 0 ? void 0 : _j[supportedLocale],
                            localization_origin: origin,
                        });
                    }
                }
            };
            const setSupportedLocale = () => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                // TODO only run this condition during dev.
                if (!didSetLocalizationResourceRun) {
                    throw new Error('Dev error: Run setLocalizationResource() first');
                }
                data.supported_locales = (_a = data.supported_locales) !== null && _a !== void 0 ? _a : {};
                data.supported_locales[locale] = {
                    locale,
                    last_updated: new Date(),
                    version: 1,
                    status: types_1.LocalizationStatus.IN_PROGRESS,
                    localization_origin: origin,
                };
                // Handle version bump up and set status to IN_PROGRESS
                const currLocalizationResource = (_b = entry === null || entry === void 0 ? void 0 : entry.localization_resources) === null || _b === void 0 ? void 0 : _b[locale];
                if (((_c = data.localization_resources) === null || _c === void 0 ? void 0 : _c[locale]) && currLocalizationResource) {
                    const currVersion = (_f = (_e = (_d = entry === null || entry === void 0 ? void 0 : entry.supported_locales) === null || _d === void 0 ? void 0 : _d[locale]) === null || _e === void 0 ? void 0 : _e.version) !== null && _f !== void 0 ? _f : 0;
                    const currStatus = (_j = (_h = (_g = entry === null || entry === void 0 ? void 0 : entry.supported_locales) === null || _g === void 0 ? void 0 : _g[locale]) === null || _h === void 0 ? void 0 : _h.status) !== null && _j !== void 0 ? _j : types_1.LocalizationStatus.IN_PROGRESS;
                    data.supported_locales[locale].version = currVersion + (isDiff() ? 1 : 0);
                    data.supported_locales[locale].status = isDiff() ? types_1.LocalizationStatus.IN_PROGRESS : currStatus;
                }
            };
            const setSortIndex = () => {
                var _a;
                // Prepare cleanedUpEntry by cloning the current entry and removing old sort index metadata.
                cleanedUpEntry = cleanedUpEntry !== null && cleanedUpEntry !== void 0 ? cleanedUpEntry : entry;
                cleanedUpEntry = Object.assign(Object.assign({}, cleanedUpEntry), { metadata: Object.assign({}, cleanedUpEntry === null || cleanedUpEntry === void 0 ? void 0 : cleanedUpEntry.metadata) });
                (_a = cleanedUpEntry.metadata) === null || _a === void 0 ? true : delete _a.localization_resources_sort_index;
                data.metadata = {
                    localization_resources_sort_index: {
                        namespaces: Object.fromEntries(namespaces.map(({ namespace }, index) => [namespace, index])),
                        messages: Object.fromEntries(namespaces.map(({ namespace, messages }) => [
                            namespace,
                            Object.fromEntries(Object.keys(messages).map((key, index) => [key, index])),
                        ])),
                    },
                };
            };
            const setLocalizationResourceHistory = () => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                const isNew = !((_a = entry === null || entry === void 0 ? void 0 : entry.localization_resources) === null || _a === void 0 ? void 0 : _a[locale]);
                if (isDiff() || isNew) {
                    const { version, status, last_updated } = (_c = (_b = data.supported_locales) === null || _b === void 0 ? void 0 : _b[locale]) !== null && _c !== void 0 ? _c : {};
                    if (!version || !status || !last_updated) {
                        throw new Error('Internal error');
                    }
                    const base_locale_version = (_f = (_e = (_d = entry === null || entry === void 0 ? void 0 : entry.supported_locales) === null || _d === void 0 ? void 0 : _d[baseLocale]) === null || _e === void 0 ? void 0 : _e.version) !== null && _f !== void 0 ? _f : (_h = (_g = data.supported_locales) === null || _g === void 0 ? void 0 : _g[baseLocale]) === null || _h === void 0 ? void 0 : _h.version;
                    if (!base_locale_version) {
                        throw new Error('Internal error');
                    }
                    localizationResourceDataSet.add(Object.assign({ locale,
                        base_locale_version,
                        version,
                        status,
                        last_updated, localization_resource: (_j = data.localization_resources) === null || _j === void 0 ? void 0 : _j[locale], localization_origin: origin }, ((entry === null || entry === void 0 ? void 0 : entry.library_resource_id) ? { library_resource_id: entry === null || entry === void 0 ? void 0 : entry.library_resource_id } : {})));
                }
            };
            if (baseLocale === locale) {
                // Base Locale
                setInitialData();
                setLocalizationResource();
                invalidateAllLocales();
                setSupportedLocale();
                setSortIndex();
                setLocalizationResourceHistory();
            }
            else {
                // Any other locales
                setLocalizationResource();
                setSupportedLocale();
                setLocalizationResourceHistory();
            }
            if (cleanedUpEntry) {
                // Overwrite the entire document with cleanedUpEntry to clear outdated content before the usual merge.
                yield this.setDatabaseEntry(cleanedUpEntry);
            }
            yield this.updateDatabaseEntry(data);
            // Save localization_resource history
            if (localizationResourceDataSet.size) {
                for (const localizationResourceData of localizationResourceDataSet) {
                    const { locale, version } = localizationResourceData;
                    if (!locale || !version) {
                        throw new Error(`Internal error ${JSON.stringify(localizationResourceData)}`);
                    }
                    yield this.setDatabaseLocalizationResourceEntry(locale, version, localizationResourceData);
                }
            }
        });
    }
    setStatus(locale, newStatus) {
        var _a, _b, _c, _d, _e, _f;
        return __awaiter(this, void 0, void 0, function* () {
            const entry = yield this.getDatabaseEntry();
            if (!entry) {
                throw new utils_1.CodedError('E_NOT_FOUND', 'Document not found');
            }
            const currStatus = (_b = (_a = entry.supported_locales) === null || _a === void 0 ? void 0 : _a[locale]) === null || _b === void 0 ? void 0 : _b.status;
            if (currStatus === undefined) {
                throw new utils_1.CodedError('E_INVALID_LOCALE', `Cannot change status of locale '${locale}' that has no content yet`);
            }
            if (currStatus === newStatus) {
                // if newStatus is the same as existing, do nothing.
                return;
            }
            if (newStatus === types_1.LocalizationStatus.NOT_STARTED) {
                throw new utils_1.CodedError('E_STATE', `Can't change from "${currStatus}" to "${types_1.LocalizationStatus.NOT_STARTED}"`);
            }
            const data = {
                supported_locales: { [locale]: { status: newStatus } },
            };
            // If changing status from READY to IN_REVIEW or IN_PROGRESS, bump up the version, and set a new localization resource history documentation.
            const version = (_e = (_d = (_c = entry.supported_locales) === null || _c === void 0 ? void 0 : _c[locale]) === null || _d === void 0 ? void 0 : _d.version) !== null && _e !== void 0 ? _e : 0;
            if (currStatus === types_1.LocalizationStatus.READY && ((_f = data === null || data === void 0 ? void 0 : data.supported_locales) === null || _f === void 0 ? void 0 : _f[locale])) {
                const newVersion = version + 1;
                data.supported_locales[locale].version = newVersion;
                const localizationResourceData = yield this.getDatabaseLocalizationResourceEntry(locale, version);
                if (!localizationResourceData) {
                    throw new Error('Internal error');
                }
                localizationResourceData.version = newVersion;
                localizationResourceData.status = newStatus;
                delete localizationResourceData.library_translation_id;
                yield this.setDatabaseLocalizationResourceEntry(locale, newVersion, localizationResourceData);
            }
            else {
                // Otherwise, don't bump up the version, and update the status in the localization resource history document.
                const localizationResourceData = { status: newStatus };
                yield this.updateDatabaseLocalizationResourceEntry(locale, version, localizationResourceData);
            }
            yield this.updateDatabaseEntry(data);
        });
    }
    setResourceId(libraryResourceId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.updateDatabaseEntry({ library_resource_id: libraryResourceId });
        });
    }
    setTranslationId(locale, libraryResourceId, libraryTranslationId, version) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const entry = yield this.getDatabaseEntry();
            const _version = (_c = version !== null && version !== void 0 ? version : (_b = (_a = entry === null || entry === void 0 ? void 0 : entry.supported_locales) === null || _a === void 0 ? void 0 : _a[locale]) === null || _b === void 0 ? void 0 : _b.version) !== null && _c !== void 0 ? _c : 1;
            yield this.updateDatabaseLocalizationResourceEntry(locale, _version, {
                library_resource_id: libraryResourceId,
                library_translation_id: libraryTranslationId,
            });
        });
    }
    setPreview(options) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.updateDatabaseEntry({ metadata: { preview: options } });
        });
    }
    getId() {
        return this.id;
    }
    getDisplayName(entry) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const id = this.getId();
            let thisEntry = entry;
            if (!thisEntry) {
                thisEntry = yield this.getDatabaseEntry();
            }
            if (id.startsWith('activities.') || id.startsWith('resources.') || id.startsWith('resources_pdf.')) {
                return thisEntry === null || thisEntry === void 0 ? void 0 : thisEntry.human_id;
            }
            return (_c = (_b = (_a = thisEntry === null || thisEntry === void 0 ? void 0 : thisEntry.metadata) === null || _a === void 0 ? void 0 : _a.preview) === null || _b === void 0 ? void 0 : _b.info) === null || _c === void 0 ? void 0 : _c.display_name;
        });
    }
    getBaseLocale(entry) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            let thisEntry = entry;
            if (!thisEntry) {
                thisEntry = yield this.getDatabaseEntry();
            }
            return (_b = (_a = thisEntry === null || thisEntry === void 0 ? void 0 : thisEntry.base_locale) !== null && _a !== void 0 ? _a : this.initBaseLocale) !== null && _b !== void 0 ? _b : defaultInitBaseLocale;
        });
    }
    getMessages(locale, options) {
        var _a, _b, _c, _d, _e, _f;
        return __awaiter(this, void 0, void 0, function* () {
            const { version, stableOutput, addIdentityMetadata, setLastExportedAt } = options !== null && options !== void 0 ? options : {};
            if (addIdentityMetadata && !stableOutput) {
                throw new Error('The addIdentityMetadata option can only be used when stableOutput is also enabled');
            }
            const entry = (_a = options === null || options === void 0 ? void 0 : options.entry) !== null && _a !== void 0 ? _a : (yield this.getDatabaseEntry());
            if (!entry) {
                throw new utils_1.CodedError('E_NOT_FOUND', 'Document not found');
            }
            let localizationResource = (_b = entry === null || entry === void 0 ? void 0 : entry.localization_resources) === null || _b === void 0 ? void 0 : _b[locale];
            const latestVersion = (_e = (_d = (_c = entry.supported_locales) === null || _c === void 0 ? void 0 : _c[locale]) === null || _d === void 0 ? void 0 : _d.version) !== null && _e !== void 0 ? _e : 0;
            if (version !== undefined) {
                if (version < 1 || version > latestVersion) {
                    throw new RangeError(`Version must be between 1 and ${latestVersion}. Provided version: ${version}`);
                }
                else if (version < latestVersion) {
                    const localizationResourceEntry = yield this.getDatabaseLocalizationResourceEntry(locale, version);
                    if (!localizationResourceEntry) {
                        throw new utils_1.CodedError('E_NOT_FOUND', `Localization content for locale '${locale}' version ${version} not found`);
                    }
                    localizationResource = localizationResourceEntry === null || localizationResourceEntry === void 0 ? void 0 : localizationResourceEntry.localization_resource;
                }
            }
            if (!localizationResource) {
                return null;
            }
            if (stableOutput) {
                const orderedNamespaces = new Map();
                if (addIdentityMetadata) {
                    orderedNamespaces.set('_identity', { id: this.getId(), locale });
                }
                const sortIndex = ((_f = entry.metadata) === null || _f === void 0 ? void 0 : _f.localization_resources_sort_index) || {};
                const sortedNamespaces = Object.keys(localizationResource).sort((a, b) => { var _a, _b, _c, _d; return ((_b = (_a = sortIndex.namespaces) === null || _a === void 0 ? void 0 : _a[a]) !== null && _b !== void 0 ? _b : 0) - ((_d = (_c = sortIndex.namespaces) === null || _c === void 0 ? void 0 : _c[b]) !== null && _d !== void 0 ? _d : 0); });
                for (const namespace of sortedNamespaces) {
                    const messages = localizationResource[namespace];
                    const orderedMessages = new Map();
                    Object.keys(messages)
                        .sort((a, b) => { var _a, _b, _c, _d, _e, _f; return ((_c = (_b = (_a = sortIndex.messages) === null || _a === void 0 ? void 0 : _a[namespace]) === null || _b === void 0 ? void 0 : _b[a]) !== null && _c !== void 0 ? _c : 0) - ((_f = (_e = (_d = sortIndex.messages) === null || _d === void 0 ? void 0 : _d[namespace]) === null || _e === void 0 ? void 0 : _e[b]) !== null && _f !== void 0 ? _f : 0); })
                        .forEach((key) => {
                        orderedMessages.set(key, messages[key]);
                    });
                    orderedNamespaces.set(namespace, Object.fromEntries(orderedMessages));
                }
                localizationResource = Object.fromEntries(orderedNamespaces);
            }
            if (setLastExportedAt) {
                yield this.updateDatabaseEntry({ supported_locales: { [locale]: { last_exported_at: new Date() } } });
            }
            return localizationResource;
        });
    }
    getLocaleHistory(locale) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.getDatabaseLocalizationResourceEntries(locale);
        });
    }
    databaseEntryExists() {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error('databaseEntryExists not implemented');
        });
    }
    getDatabaseEntry() {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error('getDatabaseEntry not implemented');
        });
    }
    setDatabaseEntry(entry) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error(`setDatabaseEntry not implemented, ${entry}`);
        });
    }
    updateDatabaseEntry(entry) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error(`updateDatabaseEntry not implemented, ${entry}`);
        });
    }
    getDatabaseLocalizationResourceEntry(locale, version) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error(`getLocalizationResourceDatabaseEntry not implemented, ${locale}, ${version}`);
        });
    }
    getDatabaseLocalizationResourceEntries(locale) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error(`getDatabaseLocalizationResourceEntries not implemented, ${locale}`);
        });
    }
    setDatabaseLocalizationResourceEntry(locale, version, entry) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error(`setDatabaseLocalizationResourceEntry not implemented, ${locale}, ${version} ${entry}`);
        });
    }
    updateDatabaseLocalizationResourceEntry(locale, version, entry) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error(`updateDatabaseLocalizationResourceEntry not implemented, ${locale}, ${version} ${entry}`);
        });
    }
}
exports.Localization = Localization;
//# sourceMappingURL=localization.js.map